import type { Nullish } from '@iheartjane/types';

export const PROMPTS = {
  bankLinking: '__jane_bloom_bank_linking_prompt',
  login: '__jane_bloom_login_prompt',
};

export type PromptsType = (typeof PROMPTS)[keyof typeof PROMPTS];

export function getPromptCookieName(
  prompt: PromptsType,
  cookiePrefix: Nullish<string>
): string {
  return `${cookiePrefix ?? ''}${prompt}`;
}
